import Role from "../../lib/Role";

/**
 * @return {boolean}
 */
function CanReviewTemplateData(loggedInUser, template) {
    const isSecondLevelOnly = template.secondLevelReviewEnabled
        && Array.isArray(template.secondLevelReviewers)
        && template.secondLevelReviewers.map(r => r.id).indexOf(loggedInUser.id) >= 0
        && template.reviewers.map(r => r.id).indexOf(loggedInUser.id) < 0;

    if (isSecondLevelOnly) {
        return false;
    }

    if (loggedInUser.role === Role.ADMIN) {
        return true;
    }

    return (loggedInUser.role === Role.REVIEWER
        || loggedInUser.role === Role.MANAGER)
        && template.reviewers.map(r => r.id).indexOf(loggedInUser.id) >= 0;
}
export default CanReviewTemplateData;